import CssBaseline from '@mui/material/CssBaseline';
import Loader from 'Components/Loader';
import UserFeedback from 'Components/UserFeedback';
import React from 'react';
import { useSelector } from 'react-redux';
import { RouterProvider } from 'react-router';
import { router } from './router';

const App = () => {
    const booting = useSelector(state => state.ui.booting);

    if (booting) {
        return <Loader/>;
    }

    return (
        <>
            <CssBaseline/>
            <UserFeedback/>
            <RouterProvider router={router}/>
        </>
    );
};

export default App;
